// extracted by css-extract-rspack-plugin
export default {"modalContent":"Zy4YA","modalHeader":"VUQjI","modalBody":"X7hdy","modalBodyGrid":"Nyrkp","modalBodyLoader":"m5UZX","modalBodyColumn":"a8aWd","modalFooter":"tBCuA"};